
export { isCoreLookupObject } from "./lib/lookupHelpers"